export const defaultNumericIdOption = () => ({ ...{ name: '', id: -1 } });
export const defaultEmptyValueOption = () => ({ ...{ name: '', value: '' } });
export const defaultApiParamStr = '?per_page=500&page=1';
